module.exports = __webpack_public_path__ + "static/dolly5-3b89eeedbe24c06306633bbce258f65e.jpg";